import useNavigate from "core/hooks/useNavigate";
import { motion } from "framer-motion";
import useMountEffect from "core/hooks/useMountEffect";
import { useLocation } from "react-router";

const AnimatedProductPageContainer = ({ direction = null, children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const locationHasState = !!location.state;

  useMountEffect(() => {
    // navigate(location.pathname, { state: null, replace: true });
  });

  return (
    <motion.div
      initial={{
        opacity: locationHasState ? 0 : 1,
        // x: locationHasState ?
      }}
      exit={{
        // x: window.scrollY > 50 ? 0 : 150,
        opacity: 0,
        // x: isForwards ? -150 : isBackwards ? 150 : 0,
      }}
      animate={{
        opacity: 1,
        x: 0,
      }}
      transition={{
        x: {
          duration: 0.4,
        },
        opacity: {
          duration: 0.5,
        },
      }}
      style={{ width: "100%" }}
      data-test="product-page-container"
    >
      {children}
    </motion.div>
  );
};
export default AnimatedProductPageContainer;
